import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import React from 'react';
import { useDispatch } from 'react-redux';
import BuzzModal from '../../../../components/BuzzModal/BuzzModal';
import { patchApproveRejectAsync } from './appListStoreSlice';
import { toast } from 'react-toastify';

const ApproveReject = ({ _id, open = false, onClose = '' }) => {
  const [age, setAge] = React.useState(null);
  const handleChange = (event) => {
    setAge(event.target.value);
  };
  const dispatch = useDispatch();
  // const { patchrejectapprove } = useSelector((state) => {
  //   const { appListReducer } = state;

  //   return { patchrejectapprove: appListReducer.patchrejectapprove };
  // });

  const approved = async () => {
    try {
      let payload = {
        _id,
        approved: true,
      };
      console.log('statussss', payload);
      dispatch(patchApproveRejectAsync(payload))
        .unwrap()
        .then((res) => {
          toast.success(`Approved successfully.`);
          // fetchData();
          // handleClose();
        });
    } catch (error) {
      toast.error('Approved failed, please try again in some time!');
    }
  };

  const rejected = async () => {
    try {
      let payload = {
        _id,
        approved: false,
      };
      // console.log('statussss',payload)
      dispatch(patchApproveRejectAsync(payload))
        .unwrap()
        .then((res) => {
          toast.success(`successfully Rejected.`);
        });
    } catch (error) {
      toast.error('rejection failed, please try again in some time!');
    }
  };

  return (
    <BuzzModal
      width={'30vw'}
      open={open}
      title={`Update SHA`}
      onClose={onClose}>
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">Approve/Reject</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={age}
          label="Age"
          onChange={handleChange}>
          <MenuItem value={true} onClick={approved}>
            approve
          </MenuItem>
          <MenuItem value={false} onClick={rejected}>
            Rejected
          </MenuItem>
        </Select>
      </FormControl>
    </BuzzModal>
  );
};

export default ApproveReject;
